module.exports = __webpack_public_path__ + "img/omar-pfp.4bc6a6fc.png";